module.exports = __webpack_public_path__ + "static/media/vw-t50.dda27e9e.jpg";